import { combineReducers } from 'redux';

// Reducers
import authReducer from './authReducer';
import organizationReducer from './organizationReducer';
import logsReducer from './logsReducer';

export default combineReducers ({
	auth: authReducer,
	organization: organizationReducer,
	logs: logsReducer
});
